import SairaRegular from '../quotes/pdf/Saira-Regular.ttf';
import SairaBold from '../quotes/pdf/Saira-Bold.ttf';

let fontsReady = false;

// Genera el PDF en el navegador, igual que la cotización: la librería se carga
// bajo demanda y sólo al exportar.
export async function downloadPlanPdf(plan) {
  const { pdf, Font } = await import('@react-pdf/renderer');
  const { default: PlanPdf } = await import('./PlanPdf');
  const { createElement } = await import('react');

  if (!fontsReady) {
    Font.register({
      family: 'Saira',
      fonts: [{ src: SairaRegular }, { src: SairaBold, fontWeight: 'bold' }],
    });
    // Sin esto @react-pdf parte palabras con guiones a media línea.
    Font.registerHyphenationCallback((word) => [word]);
    fontsReady = true;
  }

  const blob = await pdf(createElement(PlanPdf, { plan })).toBlob();
  const url = URL.createObjectURL(blob);
  const name = (plan.cliente || 'Cliente').trim().replace(/[\\/:*?"<>|]/g, '') || 'Cliente';

  const link = document.createElement('a');
  link.href = url;
  link.download = `Plan de implementación - ${name}.pdf`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
